export default {
  Decree123: 1,
  Decree51: 0,
};
